import { useEffect } from 'react';

import { revalidate } from '../client/cache';

import type { EchoSnapshot } from '../types';
import type { SetEchoState } from './useEchoState';

/**
 * When the snapshot changes, the changes are synced back to state. If the snapshot is a preview,
 * we'll refetch the URL in order to render the latest changes.
 */
export function useEchoRevalidate({ id, url, isPreview }: EchoSnapshot, setState: SetEchoState): void {
  useEffect(() => {
    const controller = new AbortController();
    const resolveState: SetEchoState = state => {
      if (!controller.signal.aborted) setState(state);
    };

    if (isPreview) {
      void revalidate({ url, signal: controller.signal }).then(
        fresh => resolveState({ status: 'ok', echo: fresh, isPreview: false }),
        error => resolveState({ status: 'error', error })
      );
    }

    return () => controller.abort();
  }, [id, url, isPreview, setState]);
}
